// @core/api/endpoints/calendar/list_events.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEventsResponse,
} from '../../../types/calendar';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/calendar';

/**
 * List events
 * Returns events in a calendar within the specified date range. Includes materialized recurring event instances. Supports filtering by event type, status, and attendee.
 */
export async function ListEvents(
  calendar_id: string,
  params?: PaginatedRequest & {
    sort_by?: string | number | boolean;
    sort_desc?: string | number | boolean;
    time_max?: string | number | boolean;
    time_min?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListEventsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id/events`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  const requestOptions = options;
  return client.get<ListEventsResponse>(requestPath, { ...requestOptions, params });
}
